module.exports = __webpack_public_path__ + "static/media/Respiratory.a58bdee5.webp";